import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Confirmacion de una accion destructiva, el equivalente al `dialog.confirm(..., {danger: true})`
 * de tienda-admin. Es un modal propio y no un `window.confirm`: el nativo bloquea la pagina entera y
 * no se puede estilar con el tema oscuro.
 */
export const ConfirmarAccion = ({ mensaje, confirmLabel = "Confirmar", onConfirmar, onCancelar }) => (
    <div className="cuenta-usuarios__overlay" onClick={onCancelar}>
        <div className="cuenta-usuarios__modal cuenta-usuarios__modal--chico" onClick={(e) => e.stopPropagation()}>
            <div className="cuenta-usuarios__modal-body cuenta-usuarios__confirmar">
                <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" size="2x" />
                <p>{mensaje}</p>
            </div>
            <div className="cuenta-usuarios__modal-foot">
                <button type="button" className="button" data-type="secondary" onClick={onCancelar}>
                    Cancelar
                </button>
                <button type="button" className="button cuenta-usuarios__boton-peligro" onClick={onConfirmar}>
                    {confirmLabel}
                </button>
            </div>
        </div>
    </div>
);
